export default "__VITE_ASSET__C1aI38WJ__"